import { queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../../../core/api/queries";
import { AgencyBillingSetupIntent, AgencyBillingSummary } from "./types";

// TODO: drop the `as any` casts and the local types in `./types.ts` once the
// `agency_billing/*` endpoints land in the OpenAPI schema (see CLAUDE.md schema
// update flow).
export default createQueryGroup(({ api }) => ({
  summary: () =>
    queryOptions({
      queryKey: ["agency_billing", "summary"],
      queryFn: (): Promise<AgencyBillingSummary> => api.get("./billing/summary", {}),
    }),
  setupIntent: () =>
    queryOptions({
      queryKey: ["agency_billing", "setup_intent"],
      queryFn: (): Promise<AgencyBillingSetupIntent> => api.post("./billing/setup_intent", {}),
      staleTime: 0,
      gcTime: 0,
    }),
}));
